<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Create Media Request</h1>
        </div>

        <div class="modal-body no-pad">
            <div class="flex h-full">
                <div class="media-request-sidebar h-full">
                    <div class="mb-4 text-center">
                        <span class="fa-layers fa-4x mb-3">
                            <i class="fa fa-circle"></i>
                            <i class="fas fa-user fa-inverse" data-fa-transform="shrink-6.5"></i>
                        </span>

                        <p class="text-lg font-light">New Media Request</p>
                    </div>

                    <div class="mb-3">

                    </div>
                </div>

                <div class="media-request-body">
                    <h2>Create Media Request</h2>

                    <div class="form-field">
                        <label>Name</label>
                        <input v-model="mediaRequest.req_name" type="text">
                    </div>

                    <div class="form-field">
                        <label>Email</label>
                        <input v-model="mediaRequest.req_email" type="text">
                    </div>

                    <div class="form-field">
                        <label>Publication</label>
                        <input v-model="mediaRequest.req_publication" type="text">
                    </div>

                    <div class="form-field">
                        <label>Subject</label>
                        <input v-model="mediaRequest.req_subject" type="text">
                    </div>

                    <div class="form-field">
                        <label>Brief</label>
                        <textarea v-model="mediaRequest.req_brief" rows="10"></textarea>
                    </div>

                    <div class="form-field">
                        <label>Request Deadline</label>

                        <simple-date-time-picker
                            v-model="mediaRequest.req_deadline">
                        </simple-date-time-picker>
                    </div>

                    <div class="form-field">
                        <label>Request Schedule</label>

                        <simple-date-time-picker
                            v-model="mediaRequest.req_datetime">
                        </simple-date-time-picker>
                    </div>

                    <div class="form-field">
                        <label>Sector</label>
                        <picker-selector
                            v-if="sectors.length > 0"
                            placeholder="Select Sectors"
                            v-model="mediaRequest.req_sectors"
                            input-name="sectors[]"
                            @update:modelValue="addSectors"
                            :options="sectors">
                        </picker-selector>
                    </div>

                    <div class="form-field">
                        <label>Location</label>
                        <picker-selector
                            v-if="locations.length > 0"
                            placeholder="Select Locations"
                            v-model="mediaRequest.req_locations"
                            input-name="locations[]"
                            @input="addLocations"
                            :options="locations">
                        </picker-selector>
                    </div>

                    <div class="form-field">
                        <label>Pre-authorise?</label>
                        <CheckBox v-model="mediaRequest.req_authorised"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="flex">
                <div class="left text-left">

                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveForm">Save</button>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import {useStore} from "vuex"

export default {
    name: 'MediaRequestCreate',
    props: {
        //
    },
    data() {
        return {
            dirty: false,
            mediaRequest: {
                req_locations: null,
                req_sectors: null,
                req_datetime: null,
                req_deadline: null,
                req_brief: null,
                req_subject: null,
                req_email: null,
                req_name: null,
                req_publication: null,
                req_authorised: true,
            },
            originalValues: null,
        }
    },
    components: {
        //
    },
    computed: {
        sectors () {
            const store = useStore()
            return store.state.sectors ?? []
        },

        locations () {
            const store = useStore()
            return store.state.locations ?? []
        },
    },
    beforeMount() {
        this.originalValues = _.clone(this.mediaRequest)

        // Auto-load query string parameters into the relative fields
        let queryKeys = Object.keys(this.$route.query)
        if (queryKeys.length > 0) {
            for (let i = 0; i < queryKeys.length; i++) {
                if (typeof this.mediaRequest['req_' + queryKeys[i]] !== 'undefined') {
                    this.mediaRequest['req_' + queryKeys[i]] = this.$route.query[queryKeys[i]]
                }
            }
        }
    },
    mounted() {
        this.setMetaTitle('Create Media Request | JournoLink Control')
    },
    methods: {
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            if (!this.dirty || confirm('Are you sure you want to close?')) {
                this.setMetaTitle('List Media Requests | JournoLink Control')
                this.$root.goBack()
            }
        },
        /**
         *
         */
        saveForm() {
            axios.post(route('mediarequests.create'), this.formatMediaRequestForSave(this.mediaRequest))
                .then(response => {
                    this.$bus.$emit('alert.success', 'Media Request Created')
                    this.dirty = false
                    this.closeView()
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * Format the media request object for save
         *
         * @param  {Object} mediaRequest
         * @return {Object}
         */
        formatMediaRequestForSave(mediaRequest) {
            let request = _.clone(mediaRequest)
            request.req_deadline = request.req_deadline && moment(request.req_deadline).format('YYYY-MM-DD HH:mm:ss')
            request.req_datetime = request.req_datetime && moment(request.req_datetime).format('YYYY-MM-DD HH:mm:ss')

            return request
        },
        addLocations(ids) {
            this.mediaRequest.req_locations = ids
        },
        addSectors(ids) {
            this.mediaRequest.req_sectors = ids
        },
    },
    watch: {
        mediaRequest: {
            handler(to) {
                if (!moment(to.req_deadline, 'YYYY-MM-DDTHH:mm:ss', true).isValid()) {
                    this.mediaRequest.req_deadline = moment(to.req_deadline).toISOString(true)
                }
                if (!moment(to.req_datetime, 'YYYY-MM-DDTHH:mm:ss', true).isValid()) {
                    this.mediaRequest.req_datetime = moment(to.req_datetime).toISOString(true)
                }

                if (_.filter(to, (val, key) => val !== this.originalValues[key]).length) {
                    this.dirty = true
                }
            },
            deep: true,
        },
    }
}
</script>

<style lang="less">
.media-request-sidebar {
    padding: 15px;
    width: 350px;
    font-size: 0.9rem;
    background: #f6f6f6;
    flex-shrink: 0;

    label {
        font-weight: bold;
        font-size: 0.8em;
        color: #999999;
    }

    p {
        margin-bottom: 0.5em;
    }
}

.media-request-body {
    flex: 1;
    padding: 15px;
    max-width: calc(100% - 350px);
}

.media-request-activity {
    width: 250px;
    font-size: 0.9rem;
    padding: 15px;
}
</style>
